package uk.co.happyukrainians

import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.engine.js.JsClient

actual fun HttpClientEngineForPlatform(): HttpClientEngine = JsClient().create()